import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";

import { CommonState } from "../state";

import { ACTION_PREFIX } from "./sms-notification-settings.action";
import { SmsNotificationSettings } from "./sms-notification-settings.model";

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated - [fabric-deprecated] - Use SmsNotificationSettingsService from app-account mfe instead
 */
export class SmsNotificationSettingsSelector {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetSmsNotificationSettings) instead
	 */
	get() {
		return (state: CommonState): SmsNotificationSettings | undefined => state.smsNotification.settings;
	}

	isBusy() {
		return (state: CommonState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}
}
